import { Quote } from "lucide-react";
import { Marquee } from "@/components/Marquee";
import { TESTIMONIALS } from "@/lib/site";

/**
 * Social proof ticker. NOTE: the data in `site.ts` is placeholder text and must
 * be replaced with genuine client feedback before launch.
 */
export function Testimonials() {
  return (
    <section
      aria-label="What clients say"
      className="border-y border-border/60 bg-secondary/40 py-16 sm:py-20"
    >
      <div className="mx-auto max-w-6xl px-6 lg:px-10">
        <p className="eyebrow text-center">In their words</p>
      </div>

      <Marquee duration={46} className="mt-10" gap="1.25rem">
        {TESTIMONIALS.map(t => (
          <figure
            key={t.name + t.context}
            className="flex w-[19rem] shrink-0 flex-col justify-between border border-border/70 bg-background p-6 sm:w-[22rem]"
          >
            <Quote className="h-4 w-4 shrink-0 text-gold/70" strokeWidth={1.5} />
            <blockquote className="mt-4 font-display text-lg leading-snug font-light">
              {t.quote}
            </blockquote>
            <figcaption className="mt-6 border-t border-border pt-4">
              <span className="block font-sans text-[0.6875rem] tracking-[0.2em] uppercase">
                {t.name}
              </span>
              <span className="mt-1 block font-sans text-[0.5625rem] tracking-[0.22em] text-muted-foreground uppercase">
                {t.context}
              </span>
            </figcaption>
          </figure>
        ))}
      </Marquee>
    </section>
  );
}
